<template>
  <div class="login">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
    >
      <h3 class="title">老年多模态多媒体语料库切分标注平台</h3>
      <el-form-item prop="username">
        <el-input
          v-model="loginForm.username"
          type="text"
          auto-complete="off"
          placeholder="账号"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        >
        </el-input>
      </el-form-item>
      <el-form-item style="width: 100%">
        <el-button
        class="el-button-custom"
          :loading="loading"
          size="medium"
          style="width: 100%"
          @click.native.prevent="handleLogin"
        >
          <span v-if="isLogin">登 录</span>
          <span v-else>注 册</span>
        </el-button>
        <div style="float: right">
          <a class="goRegister" @click="isLogin = !isLogin">{{
            isLogin ? "立即注册" : "去登录"
          }}</a>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { login, register, getUserInfo } from "../utils/login";
export default {
  name: "Login",
  data() {
    return {
      codeUrl: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }],
      },
      loading: false,
      isLogin: true,
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            username: this.loginForm.username,
            password: this.loginForm.password,
          };
          const registerParams = {
            userName: this.loginForm.username,
            userPassword: this.loginForm.password,
          };
          try {
            const res = this.isLogin
              ? await login(params)
              : await register(registerParams);
            this.loading = false;
            let msg = "登录成功";
            this.$message({
              message: this.isLogin ? msg : "注册成功，请登录！",
              type: "success",
            });
            if (this.isLogin) {
              getUserInfo(res.data.userId).then((res) => {
                let result = res.data;
                result.userName = this.loginForm.username;
                this.$store.commit("SET_USER_INFO", result);
                // this.$router.push("./index");
              });
            } else {
              this.isLogin = true;
            }
            this.$emit('loginSuccess')
          } catch (error) {
            console.log(error)
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="less">
.goRegister {
  color: #568156;
  cursor: pointer;
}
.el-button-custom{
  background: #568156;
  color: #fff;
}
.el-button-custom:focus, .el-button-custom:hover{
    color: #fff;
    border-color: #568156;
    background-color: #568156;
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
  background: #568156;
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #568156;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
    width: 100%;
    height: 100%;
  }
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
.login-code-img {
  height: 38px;
}
</style>
